import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Booking from "@/pages/Booking";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ArtistDashboard from "@/pages/ArtistDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import BillingSuccess from "@/pages/BillingSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SharePreview from "@/pages/SharePreview";
import ArtistAudit from "@/pages/ArtistAudit";
import StructureOnboarding from "@/pages/StructureOnboarding";
import SplitSheets from "@/pages/SplitSheets";
import SplitSheetSign from "@/pages/SplitSheetSign";
import Royalties from "@/pages/Royalties";

import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/share/anime/:token" element={<SharePreview />} />
            <Route path="/audit" element={<ArtistAudit />} />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <StructureOnboarding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/split-sheets"
              element={
                <ProtectedRoute>
                  <SplitSheets />
                </ProtectedRoute>
              }
            />
            <Route path="/split-sheet/sign/:token" element={<SplitSheetSign />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ArtistDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/royalties"
              element={
                <ProtectedRoute>
                  <Royalties />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing/success"
              element={
                <ProtectedRoute>
                  <BillingSuccess />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Landing />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
